(() => {
  if(window.smartMakroCatalogRefresh)return;
  window.smartMakroCatalogRefresh=true;
  const roots=new WeakSet();
  const init=()=>document.querySelectorAll('.sm-catalog-product').forEach(root=>{
    if(roots.has(root))return;
    roots.add(root);
    // Legacy radio names include a trailing newline. The theme's variant cards
    // select radios by a name suffix, so normalize that whitespace locally.
    const normalizeOptions=()=>root.querySelectorAll('.variant-cards__hidden-options input[name]').forEach(input=>{
      if(input.name!==input.name.trim())input.name=input.name.trim();
    });
    normalizeOptions();
    let config;
    try{config=JSON.parse(root.querySelector('[data-catalog-variants]')?.textContent||'{}');}catch{return;}
    let selectedVariantId=config.selected;
    const updateStock=id=>{
      const variant=config.variants?.find(v=>String(v.id)===String(id));
      if(!variant)return;
      selectedVariantId=variant.id;
      const stock=root.querySelector('[data-catalog-stock]');
      const text=root.querySelector('[data-catalog-stock-text]');
      const format=(variant.title||'').toLowerCase().replace(/[\s\-–—]/g,'');
      const includesEbook=variant.shipping&&/ebog|ebøger|ebook/.test(format);
      const isBook=/bog|bøger|book/.test(format);
      const backorder=Boolean(variant.managed&&variant.quantity<=0);
      const submit=root.querySelector('[id^="ProductSubmitButton-"]');
      const appPreorder=/forudbestil|pre[\s-]?order/i.test(submit?.textContent||'');
      const preorder=Boolean(variant.available&&variant.shipping&&isBook&&(backorder||appPreorder||config.physicalPreorder));
      const message=variant.famliWeek48State==='preorder'?config.messages.famliPreorder:variant.famliWeek48State==='soldout'?config.messages.soldOut:!variant.available?config.messages.soldOut:!variant.shipping?config.messages.digital:preorder?config.messages.preorderPhysical:includesEbook?(backorder?config.messages.combinedOrderable:config.messages.combined):(backorder?config.messages.orderable:config.messages.inStock);
      if(text&&text.textContent!==message)text.textContent=message;
      stock?.classList.toggle('is-sold-out',!variant.available||variant.famliWeek48State==='soldout');
      root.querySelectorAll('[data-catalog-physical]').forEach(e=>e.hidden=!variant.shipping);
      root.querySelectorAll('[data-catalog-digital]').forEach(e=>e.hidden=variant.shipping);
      root.querySelectorAll('[data-catalog-delivery]').forEach(item=>{
        const content=variant.famliWeek48State==='preorder'?config.messages.famliDelivery:variant.famliWeek48State==='soldout'?config.messages.soldOut:preorder?item.dataset.deliveryPreorder:item.dataset.deliveryDefault;
        if(content&&item.innerHTML!==content)item.innerHTML=content;
      });
    };
    updateStock(config.selected);
    const onVariant=event=>{if(!root.isConnected){document.removeEventListener('variant:changed',onVariant);return;}if(event.detail?.variant)updateStock(event.detail.variant.id);};
    document.addEventListener('variant:changed',onVariant);
    const placeRating=()=>{
      normalizeOptions();
      const target=root.querySelector('[data-catalog-rating]');

      const badge=root.querySelector('.vtl-pr__product-title-star-snippets');
      if(!target||!badge)return;
      if(badge.parentElement!==target)target.append(badge);
      if(badge.dataset.catalogAccessible)return;
      badge.dataset.catalogAccessible='true';badge.tabIndex=0;badge.setAttribute('role','link');
      const activate=event=>{
        const destination=document.querySelector('#catalog-review-preview')||document.querySelector('.vtl-pr-main-widget')||document.querySelector('[id*=vitals-product-reviews]');
        if(!destination)return;
        event.preventDefault();event.stopImmediatePropagation();
        destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      };
      badge.addEventListener('click',activate,true);badge.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' ')activate(event);});
    };
    placeRating();new MutationObserver(()=>{placeRating();updateStock(selectedVariantId);}).observe(root,{childList:true,subtree:true});
  });
  const placeReviews=()=>{
    const host=document.querySelector('[data-catalog-live-reviews]');
    const widget=document.querySelector('.vtl-pr-main-widget--product-page');
    if(!host||!widget||!widget.querySelector('.vtl-pr-ri__wrapper'))return;
    if(widget.parentElement!==host)host.append(widget);
    const section=host.closest('.sm-story');
    if(section)section.hidden=false;
    const staticReviews=section?.querySelector('.sm-story__reviews');
    if(staticReviews)staticReviews.hidden=true;
  };
  const anchors=()=>{
    if(!location.hash)return;
    let target;
    try{target=document.querySelector(location.hash);}catch{return;}
    if(!target||!target.closest('.sm-catalog-product,.sm-catalog-journey'))return;
    const details=target.matches('details')?target:target.closest('details');if(details)details.open=true;
  };
  const run=()=>{init();anchors();placeReviews();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);window.addEventListener('hashchange',anchors);
  let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;init();placeReviews();});}).observe(document.body,{childList:true,subtree:true});
})();



